import { createQueryKeys } from '@lukemorales/query-key-factory'

import { checkoutService } from '@/domain/Checkout'

export const checkout = createQueryKeys('checkout', {
    listDeliveryOptions: () => ({
        queryKey: ['allDeliveryOptions'],
        queryFn: () => checkoutService.getAllDeliveryOptions(),
    }),
    listShippingMethodsByCartId: (cartId?: string) => ({
        queryKey: ['shippingMethodsByCartId', cartId],
        queryFn: () => {
            if (!cartId) {
                return Promise.resolve([])
            }

            return checkoutService.listShippingMethodsByCartId({
                cart_id: cartId,
            })
        },
    }),
    listPaymentOptions: () => ({
        queryKey: ['allPaymentOptions'],
        queryFn: () => {},
    }),
})
